import { ca } from '@cian/analytics';

export function trackClick(label: string) {
  ca('event', {
    action: 'to_JKCard_main_block',
    category: 'card',
    label,
    name: 'oldevent',
  });
}

export function trackKPLinkClick(label: string) {
  ca('event', {
    action: 'to_KPCard_main_block',
    category: 'card',
    label,
    name: 'oldevent',
  });
}
